/**
 * Safely extracts carrier ID from a service ID by looking up the service
 * @param {string|null|undefined} serviceId - The service ID to look up
 * @param {Array} services - Array of service objects to search through
 * @returns {string} The carrier ID or empty string if not found
 */
export const getCarrierIdFromService = (serviceId, services) => {
  if (!serviceId || !Array.isArray(services)) {
    return '';
  }
  const service = services.find((s) => s?.serviceId === serviceId);
  return service?.carrierId || '';
};
